export default {
    listText: { textTransform: "capitalize" }
};
